import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const StoreRequisitionReportPrint = () => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  console.log("id:", id);
  
  const [reportData, setReportData] = useState({
    storeReqNo: '',
    date: '',
    branch: '',
    store: '',
    remarks: '',
    items: [
      { slNo: 1, itemCode: '', description: '', partNo: '', uom: '', reqQty: '', price: '', amount: '', purpose: '' }
    ],
    preparedBy: '',
    manager: '',
    approvedBy: ''
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (id) {
      fetchReportData(id);
    }
  }, [id]);

  const fetchReportData = async (id) => {
    setLoading(true);
    setError(null);
    
    try {
      const response = await fetch(`https://nissi-india.com/api/storeReq_rptPrint/${id}`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      console.log("Fetched data:", data);
      
      // Map the fetched data to your reportData structure
      // Adjust the mapping based on the actual API response structure
      const mappedData = {
        storeReqNo: data.storeReqNo || data.store_req_no || '',
        date: data.date || data.req_date || '',
        branch: data.branch || data.branch_name || '',
        store: data.store || data.store_name || '',
        remarks: data.remarks || data.notes || '',
        items: data.items ? data.items.map((item, index) => ({
          slNo: index + 1,
          itemCode: item.itemCode || item.item_code || '',
          description: item.description || item.item_description || '',
          partNo: item.partNo || item.part_no || '',
          uom: item.uom || item.unit || '',
          reqQty: item.reqQty || item.required_qty || item.quantity || '',
          price: item.price || item.unit_price || '',
          amount: item.amount || item.total_amount || '',
          purpose: item.purpose || item.remarks || ''
        })) : [
          { slNo: 1, itemCode: '', description: '', partNo: '', uom: '', reqQty: '', price: '', amount: '', purpose: '' }
        ],
        preparedBy: data.preparedBy || data.prepared_by || '',
        manager: data.manager || data.manager_name || '',
        approvedBy: data.approvedBy || data.approved_by || ''
      };
      
      setReportData(mappedData);
      
    } catch (err) {
      console.error('Error fetching report data:', err);
      setError(`Failed to fetch report data: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  const addItem = () => {
    const newItem = {
      slNo: reportData.items.length + 1,
      itemCode: '',
      description: '',
      partNo: '',
      uom: '',
      reqQty: '',
      price: '',
      amount: '',
      purpose: ''
    };
    setReportData(prev => ({
      ...prev,
      items: [...prev.items, newItem]
    }));
  };

  const updateItem = (index, field, value) => {
    const updatedItems = reportData.items.map((item, i) => 
      i === index ? { ...item, [field]: value } : item
    );
    setReportData(prev => ({ ...prev, items: updatedItems }));
  };

  const updateField = (field, value) => {
    setReportData(prev => ({ ...prev, [field]: value }));
  };

  const calculateTotal = () => {
    return reportData.items.reduce((total, item) => {
      const amount = parseFloat(item.amount) || 0;
      return total + amount;
    }, 0).toFixed(2);
  };

  return (
    <div className="max-w-4xl mx-auto p-8 bg-white text-black font-serif">
      {/* Print styles */}
      <style jsx>{`
        @media print {
          body { margin: 0; }
          .no-print { display: none !important; }
          .print-page { 
            width: 210mm; 
            min-height: 297mm; 
            margin: 0; 
            padding: 20mm;
            box-shadow: none;
            font-size: 12px;
          }
        }
      `}</style>

      {/* Loading State */}
      {loading && (
        <div className="flex justify-center items-center min-h-64">
          <div className="text-lg">Loading report data...</div>
        </div>
      )}

      {/* Error State */}
      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-6 no-print">
          <strong className="font-bold">Error: </strong>
          <span className="block sm:inline">{error}</span>
        </div>
      )}

      {/* Report Content */}
      {!loading && (

      <div className="print-page border-4 border-black p-6">
        {/* Header */}
        <div className="border-2 border-black p-4 mb-6">
          <div className="flex items-start justify-between">
            {/* Logo Placeholder */}
            <div className="w-20 h-20 border-2 border-black flex items-center justify-center text-xs">
              <div className="text-center">
                <div className="mb-1">⚒</div>
                <div className="text-xs font-bold">NISSI</div>
                <div className="text-xs">INFOTECH PVT LTD</div>
              </div>
            </div>
            
            {/* Company Details */}
            <div className="text-center flex-1 mx-8">
              <h1 className="text-2xl font-bold mb-2">Nissi Infotech</h1>
              <div className="text-sm">
                <div className="font-semibold">NISSI</div>
                <div className="font-semibold">CIVIL CONSTRUCTION</div>
                <div className="mt-2 text-xs leading-relaxed">
                  342-12, Nagappa colony, kavundampalayam-641030, Tamil Nadu, India.<br/>
                  Phone No: 9003744644 &nbsp;&nbsp;&nbsp;&nbsp; infraconsoft.implementation@nissiinfotech.in
                </div>
              </div>
            </div>

            {/* Right Logo Placeholder */}
            <div className="w-20 h-20 border-2 border-black flex items-center justify-center">
              <div className="text-center text-xs font-bold">LOGO</div>
            </div>
          </div>
        </div>

        {/* Report Title */}
        <div className="text-center mb-6">
          <h2 className="text-xl font-bold underline">Store Requisition Report</h2>
        </div>

        {/* Form Fields */}
        <div className="grid grid-cols-2 gap-6 mb-6">
          <div className="space-y-3">
            <div className="flex items-center">
              <label className="w-32 font-semibold">Store Req.No :</label>
              <input 
                type="text" 
                value={reportData.storeReqNo}
                onChange={(e) => updateField('storeReqNo', e.target.value)}
                className="flex-1 border-b border-black bg-transparent focus:outline-none no-print"
              />
              <span className="flex-1 border-b border-black min-h-6 hidden print:block">{reportData.storeReqNo}</span>
            </div>
            <div className="flex items-center">
              <label className="w-32 font-semibold">Date :</label>
              <input 
                type="date" 
                value={reportData.date}
                onChange={(e) => updateField('date', e.target.value)}
                className="flex-1 border-b border-black bg-transparent focus:outline-none no-print"
              />
              <span className="flex-1 border-b border-black min-h-6 hidden print:block">{reportData.date}</span>
            </div>
            <div className="flex items-center">
              <label className="w-32 font-semibold">Branch :</label>
              <input 
                type="text" 
                value={reportData.branch}
                onChange={(e) => updateField('branch', e.target.value)}
                className="flex-1 border-b border-black bg-transparent focus:outline-none no-print"
              />
              <span className="flex-1 border-b border-black min-h-6 hidden print:block">{reportData.branch}</span>
            </div>
          </div>
          <div className="space-y-3">
            <div className="flex items-center">
              <label className="w-24 font-semibold">Store :</label>
              <input 
                type="text" 
                value={reportData.store}
                onChange={(e) => updateField('store', e.target.value)}
                className="flex-1 border-b border-black bg-transparent focus:outline-none no-print"
              />
              <span className="flex-1 border-b border-black min-h-6 hidden print:block">{reportData.store}</span>
            </div>
            <div className="flex items-center">
              <label className="w-24 font-semibold">Remarks :</label>
              <input 
                type="text" 
                value={reportData.remarks}
                onChange={(e) => updateField('remarks', e.target.value)}
                className="flex-1 border-b border-black bg-transparent focus:outline-none no-print"
              />
              <span className="flex-1 border-b border-black min-h-6 hidden print:block">{reportData.remarks}</span>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="border-2 border-black mb-6">
          <table className="w-full">
            <thead>
              <tr className="border-b-2 border-black">
                <th className="border-r border-black p-2 text-sm font-semibold w-12">Sl.no</th>
                <th className="border-r border-black p-2 text-sm font-semibold w-20">Item Code</th>
                <th className="border-r border-black p-2 text-sm font-semibold">Description</th>
                <th className="border-r border-black p-2 text-sm font-semibold w-20">Part No</th>
                <th className="border-r border-black p-2 text-sm font-semibold w-16">UOM</th>
                <th className="border-r border-black p-2 text-sm font-semibold w-20">Req Qty</th>
                <th className="border-r border-black p-2 text-sm font-semibold w-20">Price</th>
                <th className="border-r border-black p-2 text-sm font-semibold w-20">Amount</th>
                <th className="p-2 text-sm font-semibold w-24">Purpose</th>
              </tr>
            </thead>
            <tbody>
              {reportData.items.map((item, index) => (
                <tr key={index} className="border-b border-black">
                  <td className="border-r border-black p-2 text-center text-sm">{item.slNo}</td>
                  <td className="border-r border-black p-1">
                    <input 
                      type="text" 
                      value={item.itemCode}
                      onChange={(e) => updateItem(index, 'itemCode', e.target.value)}
                      className="w-full bg-transparent text-xs focus:outline-none no-print"
                    />
                    <span className="hidden print:block text-xs min-h-4">{item.itemCode}</span>
                  </td>
                  <td className="border-r border-black p-1">
                    <input 
                      type="text" 
                      value={item.description}
                      onChange={(e) => updateItem(index, 'description', e.target.value)}
                      className="w-full bg-transparent text-xs focus:outline-none no-print"
                    />
                    <span className="hidden print:block text-xs min-h-4">{item.description}</span>
                  </td>
                  <td className="border-r border-black p-1">
                    <input 
                      type="text" 
                      value={item.partNo}
                      onChange={(e) => updateItem(index, 'partNo', e.target.value)}
                      className="w-full bg-transparent text-xs focus:outline-none no-print"
                    />
                    <span className="hidden print:block text-xs min-h-4">{item.partNo}</span>
                  </td>
                  <td className="border-r border-black p-1">
                    <input 
                      type="text" 
                      value={item.uom}
                      onChange={(e) => updateItem(index, 'uom', e.target.value)}
                      className="w-full bg-transparent text-xs focus:outline-none no-print"
                    />
                    <span className="hidden print:block text-xs min-h-4">{item.uom}</span>
                  </td>
                  <td className="border-r border-black p-1">
                    <input 
                      type="number" 
                      value={item.reqQty}
                      onChange={(e) => updateItem(index, 'reqQty', e.target.value)}
                      className="w-full bg-transparent text-xs focus:outline-none no-print"
                    />
                    <span className="hidden print:block text-xs min-h-4">{item.reqQty}</span>
                  </td>
                  <td className="border-r border-black p-1">
                    <input 
                      type="number" 
                      step="0.01"
                      value={item.price}
                      onChange={(e) => updateItem(index, 'price', e.target.value)}
                      className="w-full bg-transparent text-xs focus:outline-none no-print"
                    />
                    <span className="hidden print:block text-xs min-h-4">{item.price}</span>
                  </td>
                  <td className="border-r border-black p-1">
                    <input 
                      type="number" 
                      step="0.01"
                      value={item.amount}
                      onChange={(e) => updateItem(index, 'amount', e.target.value)}
                      className="w-full bg-transparent text-xs focus:outline-none no-print"
                    />
                    <span className="hidden print:block text-xs min-h-4">{item.amount}</span>
                  </td>
                  <td className="p-1">
                    <input 
                      type="text" 
                      value={item.purpose}
                      onChange={(e) => updateItem(index, 'purpose', e.target.value)}
                      className="w-full bg-transparent text-xs focus:outline-none no-print"
                    />
                    <span className="hidden print:block text-xs min-h-4">{item.purpose}</span>
                  </td>
                </tr>
              ))}
              {/* Empty rows for printing */}
              {Array.from({ length: Math.max(0, 5 - reportData.items.length) }).map((_, index) => (
                <tr key={`empty-${index}`} className="border-b border-black h-8">
                  <td className="border-r border-black p-2"></td>
                  <td className="border-r border-black p-2"></td>
                  <td className="border-r border-black p-2"></td>
                  <td className="border-r border-black p-2"></td>
                  <td className="border-r border-black p-2"></td>
                  <td className="border-r border-black p-2"></td>
                  <td className="border-r border-black p-2"></td>
                  <td className="border-r border-black p-2"></td>
                  <td className="p-2"></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Total Amount */}
        <div className="flex justify-end mb-8">
          <div className="flex items-center">
            <span className="font-semibold mr-4">Total Amount :</span>
            <span className="border-b border-black min-w-32 text-right px-2">{calculateTotal()}</span>
          </div>
        </div>

        {/* Signatures */}
        <div className="grid grid-cols-3 gap-8 mb-8">
          <div className="text-center">
            <div className="font-semibold mb-16">Prepared By</div>
            <input 
              type="text" 
              value={reportData.preparedBy}
              onChange={(e) => updateField('preparedBy', e.target.value)}
              className="w-full border-b border-black bg-transparent text-center focus:outline-none no-print"
            />
            <div className="hidden print:block border-b border-black min-h-6">{reportData.preparedBy}</div>
          </div>
          <div className="text-center">
            <div className="font-semibold mb-16">Manager</div>
            <input 
              type="text" 
              value={reportData.manager}
              onChange={(e) => updateField('manager', e.target.value)}
              className="w-full border-b border-black bg-transparent text-center focus:outline-none no-print"
            />
            <div className="hidden print:block border-b border-black min-h-6">{reportData.manager}</div>
          </div>
          <div className="text-center">
            <div className="font-semibold mb-16">Approved By</div>
            <input 
              type="text" 
              value={reportData.approvedBy}
              onChange={(e) => updateField('approvedBy', e.target.value)}
              className="w-full border-b border-black bg-transparent text-center focus:outline-none no-print"
            />
            <div className="hidden print:block border-b border-black min-h-6">{reportData.approvedBy}</div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-between items-center text-xs mt-auto pt-8 border-t border-black">
          <div>Report generated by ERP-Software - www.infraconsoft.com owned by www.nissiinfotech.com</div>
          <div>Page 1 of 1</div>
        </div>
        </div>
      )}

      {/* Control Buttons */}
      {!loading && (
        <div className="flex justify-center gap-4 mt-6 no-print">
          {id && (
            <button 
              onClick={() => fetchReportData(id)}
              className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition-colors"
            >
              Refresh Data
            </button>
          )}
          <button 
            onClick={addItem}
            className="px-4 py-2 bg-gray-800 text-white rounded hover:bg-gray-700 transition-colors"
          >
            Add Item
          </button>
          <button 
            onClick={() => window.print()}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
          >
            Print Report
          </button>
        </div>
      )}
    </div>
  );
};

export default StoreRequisitionReportPrint;